import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/ui/Card';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';
import FastAPIClient from '../services/apiClient';
import logo_1024_X_1024 from '../assets/logo_1024_X_1024.png';

const ForgotPasswordPage = () => {
    const client = new FastAPIClient();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        setError('');
        setMessage('');
        try {
            const res = await client.postData('/auth/request-password-reset', { email });
            setMessage(res?.msg || res?.data?.msg || 'If an account exists, a reset link was sent.');
            setStatus('success');
        } catch (err) {
            // still show soft success if you prefer; or show detail
            setError(err?.response?.data?.detail || err.message || 'Request failed.');
            setStatus('error');
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-light p-4">
            <Card className="w-full max-w-md mx-auto p-8">
                <div className="flex justify-center mb-6">
                    <img src={logo_1024_X_1024} alt="Arxis" className="w-24 h-24 object-contain rounded-lg" />
                </div>
                <h2 className="text-2xl font-bold text-center text-text-primary mb-2">Forgot password</h2>
                <p className="text-center text-text-secondary mb-6 text-sm">
                    Enter your account email. We’ll send a link to set a new password.
                </p>
                <form onSubmit={handleSubmit} noValidate>
                    <Input
                        label="Email Address"
                        id="email"
                        name="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    {error && <p className="text-gmail-red text-sm text-center mb-4">{error}</p>}
                    {message && <p className="text-gmail-green text-sm text-center mb-4">{message}</p>}
                    <Button type="submit" fullWidth disabled={status === 'loading'} className="mt-4">
                        {status === 'loading' ? 'Sending…' : 'Send reset link'}
                    </Button>
                </form>
                <p className="text-center text-sm text-text-secondary mt-6">
                    <Link to="/login" className="text-gmail-blue hover:underline">Back to login</Link>
                </p>
            </Card>
        </div>
    );
};

export default ForgotPasswordPage;